<template>
  <div>
    <div style="text-align: right">
      <button
        type="button"
        class="btn btn-success btn-sm"
        @click="createUser()"
      >
        Crear usuario
      </button>
    </div>

    <br />

    <div class="row">
      <div class="col-sm-6">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
        >
        </el-pagination>
      </div>
      <div class="col-sm-6">
        <el-input
          v-model="search"
          size="small"
          placeholder="Buscar..."
          clearable
        ></el-input>
      </div>
    </div>

    <br />

    <el-table v-loading="loading" :data="pageData" stripe>
      <el-table-column label="ID" prop="id" :width="90"></el-table-column>
      <el-table-column label="Google ID" prop="google_id"></el-table-column>
      <el-table-column label="Nombre" prop="first_name"></el-table-column>
      <el-table-column label="Apellido" prop="last_name"></el-table-column>
      <el-table-column label="Callcenter" prop="callcenter" :width="90">
        <template slot-scope="scope">
          {{ scope.row.callcenter ? "Si" : "No" }}
        </template>
      </el-table-column>
      <el-table-column label="Admin" prop="admin" :width="90">
        <template slot-scope="scope">
          {{ scope.row.admin ? "Si" : "No" }}
        </template>
      </el-table-column>
      <el-table-column label="Creado" prop="created_at" :width="100">
        <template slot-scope="scope">
          {{
            scope.row.created_at
              ? moment(scope.row.created_at).format("DD-MM-YYYY HH:mm:ss")
              : "No hay fecha"
          }}
        </template>
      </el-table-column>
      <el-table-column label="Actualizado" prop="updated_at" :width="100">
        <template slot-scope="scope">
          {{
            scope.row.updated_at
              ? moment(scope.row.updated_at).format("DD-MM-YYYY HH:mm:ss")
              : "No hay fecha"
          }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Acciones">
        <template slot-scope="scope">
          <div style="white-space: nowrap">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="editUser(scope.row.id)"
            >
              Editar
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm"
              @click="deleteUser(scope.row.id)"
            >
              Eliminar
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <br />

    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page.sync="currentPage"
    >
    </el-pagination>

    <el-dialog :visible.sync="detailDialogVisible">
      <el-form
        v-if="editableUser"
        size="mini"
        @submit.prevent.native="saveUser()"
      >
        <el-alert
          v-for="(v, index) in validation"
          :key="index"
          :title="v.message"
          type="error"
        ></el-alert>
        <el-form-item>
          <label slot="label">Google ID</label>
          <el-input v-model="editableUser.google_id"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">Permisos</label>
          <el-checkbox
            v-model="editableUser.callcenter"
            :true-label="1"
            :false-label="0"
            >Callcenter</el-checkbox
          >
          <el-checkbox
            v-model="editableUser.admin"
            :true-label="1"
            :false-label="0"
            >Admin</el-checkbox
          >
        </el-form-item>

        <div style="text-align: right;">
          <el-form-item>
            <el-button type="success" native-type="submit">
              Guardar
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Fuse from "fuse.js";

export default {
  data() {
    return {
      loading: false,
      users: [],
      detailDialogVisible: false,
      editableUser: null,
      currentPage: 1,
      validation: [],
      search: ""
    };
  },
  computed: {
    moment() {
      return moment;
    },
    total() {
      return this.users.length;
    },
    pageSize() {
      return 100;
    },
    pageData() {
      let results = this.users;

      if (this.search) {
        results = this.fuse.search(this.search).map(d => d.item);
      }

      const offset = (this.currentPage - 1) * this.pageSize;
      return results.slice(offset, offset + this.pageSize);
    },
    fuse() {
      return new Fuse(this.users, { keys: ["google_id"] });
    }
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.loading = true;
      axios
        .get("api/v1/backend/users", { params: { google: 1 } })
        .then(response => {
          this.users = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteUser(id) {
      // eslint-disable-next-line no-alert
      if (!window.confirm("¿Está seguro que desea eliminar este usuario?"))
        return;

      axios
        .post(`api/v1/backend/users/${id}`, undefined, {
          params: { _method: "DELETE" }
        })
        .then(() => {
          this.refreshData();
        });
    },
    editUser(id) {
      this.validation = [];
      axios.get(`api/v1/backend/users/${id}`).then(response => {
        this.editableUser = response.data;
        this.detailDialogVisible = true;
      });
    },
    createUser() {
      this.validation = [];
      this.editableUser = {
        id: null,
        google_id: "",
        admin: 0,
        callcenter: 0
      };

      this.detailDialogVisible = true;
    },
    saveUser() {
      axios({
        url: this.editableUser.id
          ? `api/v1/backend/users/${this.editableUser.id}`
          : `api/v1/backend/users`,
        data: this.editableUser,
        method: this.editableUser.id ? "PUT" : "POST"
      })
        .then(() => {
          this.refreshData();
          this.detailDialogVisible = false;
        })
        .catch(err => {
          this.validation = err.response.data.errors;
        });
    }
  }
};
</script>
